import type { CommonStylesPalette } from '../types.d';

/* eslint-disable @typescript-eslint/no-unused-vars */
export const audienceReachEstimateContainerStyle = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }, { leftMargin = 900, rightMargin = 'unset', topMargin = 320 } = {}) => ({
  '& .audience-reach-estimate-container, & .reach-estimate-control-container': {
    width: 434,
    position: 'absolute',
    top: topMargin,
    left: leftMargin,
    right: rightMargin,
    margin: 0,

    '& >div': {
      width: 434,
    },

    '& .reach-estimate-control': {
      width: 434,
      '& .panel': {
        backgroundColor: palette.white,
        boxShadow: '-5px 10px 15px 0px rgba(0,0,0,0.2)',
        '-webkit-box-shadow': '-5px 10px 15px 0px rgba(0,0,0,0.2)',
        borderRadius: 2,
        padding: 20,

        '& .panel-body': {
          padding: 0,


          '& .audience-meter-container': {
            '& .audience-meter>div': {
              fontSize: 18,
            },

            '& .meter-container': {
              height: 37,
              margin: '10px 0 13px 0',
              position: 'relative',
              fontSize: 12,

              '& .arrow': {
                backgroundColor: '#107C10',
                top: 5,
                width: 16,
                height: 35,
                position: 'absolute',
                border: `4px solid ${palette.white} !important`,
                zIndex: 1,
              },

              '& div[style *= "border-top-color: green"]': {
                backgroundColor: '#107C10',
              },

              '& div[style *= "border-top-color: red"]': {
                backgroundColor: '#A80000',
              },

              '& .meter': {
                '& .specific-meter, & .broad-meter': {
                  width: '10%',
                  height: 12,
                  backgroundColor: '#C4C4C4',
                  position: 'absolute',
                  top: 17,
                },

                '& .broad-meter': {
                  width: '90%',
                  backgroundColor: '#C4C4C4',
                  marginLeft: '10%',
                },
              },

              '& .audience-specific-label': {
                position: 'absolute',
                top: 35,
                fontSize: 12,
              },

              '& .audience-broad-label': {
                position: 'absolute',
                top: 35,
                fontSize: 12,
                right: 0,
              },
            },
          },

          '& .estimate-note': {
            color: '#323130',
            fontSize: 12,
            paddingTop: 20,
          },

          '& .reach-warning': {
            width: '100%',
            display: 'none',
          },
        },
      },
    },

  },
});
